{#if item.submenu}
  <button
    class="MenuItem {item.active ? 'Active': ''}"
    data-icon-before="{item.icon}"
    data-icon-after="{`keyboard_arrow_${  opened ? 'up' : 'down'}` }"
    on:click={() => opened = !opened}
  >
    {item.label}
  </button>

  <div class="Menu {opened ? '' : 'Closed'}">
    {#each item.submenu as subitem}
      <Item item="{subitem}" />
    {/each}
  </div>

{:else}
  <button class="MenuItem {item.active ? 'Active': ''}"
          data-icon-before="{item.icon}"
          data-icon-after="{item.iconAfter}"
          on:click={() => item.action()}>{item.label}</button>

  {#if item.subitem}
    <svelte:component this={item.subitem}/>
  {/if}
{/if}


<script>
  import Item from './NavigationMaximizedLevel2MenuItem.svelte';

  export let item = {};
  let opened = item.active || item.alwaysOpened;
</script>


<style lang="stylus">
  @import './styles.blocks.styl'

  .MenuItem {
    {MenuItem}
  }

  .Menu {
    background: #263238;

    &.Closed {
      max-height: 0;
      overflow: hidden;
    }
  }
</style>
